/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const Bugs = lazyLoad(
  () => import('./index'),
  module => {
    return module.Bugs;
  },
);
